__turbopack_context__.v({
  "container": "fEo4ma_container",
  "inputNumber": "fEo4ma_inputNumber",
  "inputOperator": "fEo4ma_inputOperator",
  "inputSubmit": "fEo4ma_inputSubmit",
});
